//DO NOT MODIFY THIS MANUALLY!!!!
//Generated by running npm generate:images
interface Image {
  class: string
}

const images = {
  ag: { class: "ag" } as Image,
  animatedPaywall: {
    img1: { class: "animatedPaywallImg1" } as Image,
    img10: { class: "animatedPaywallImg10" } as Image,
    img11: { class: "animatedPaywallImg11" } as Image,
    img12: { class: "animatedPaywallImg12" } as Image,
    img13: { class: "animatedPaywallImg13" } as Image,
    img14: { class: "animatedPaywallImg14" } as Image,
    img15: { class: "animatedPaywallImg15" } as Image,
    img16: { class: "animatedPaywallImg16" } as Image,
    img17: { class: "animatedPaywallImg17" } as Image,
    img18: { class: "animatedPaywallImg18" } as Image,
    img19: { class: "animatedPaywallImg19" } as Image,
    img2: { class: "animatedPaywallImg2" } as Image,
    img3: { class: "animatedPaywallImg3" } as Image,
    img4: { class: "animatedPaywallImg4" } as Image,
    img5: { class: "animatedPaywallImg5" } as Image,
    img6: { class: "animatedPaywallImg6" } as Image,
    img7: { class: "animatedPaywallImg7" } as Image,
    img8: { class: "animatedPaywallImg8" } as Image,
    img9: { class: "animatedPaywallImg9" } as Image,
  },
  anniversaryIcon: { class: "anniversaryIcon" } as Image,
  backButton: { class: "backButton" } as Image,
  backgroundPatternLarge: { class: "backgroundPatternLarge" } as Image,
  blackFridayDecorationLeft: { class: "blackFridayDecorationLeft" } as Image,
  blackFridayDecorationRight: { class: "blackFridayDecorationRight" } as Image,
  blackFridayIcon: { class: "blackFridayIcon" } as Image,
  circleDecorationLargeLeft: { class: "circleDecorationLargeLeft" } as Image,
  circleDecorationLargeRight: { class: "circleDecorationLargeRight" } as Image,
  circleDecorationLeft: { class: "circleDecorationLeft" } as Image,
  circleDecorationRight: { class: "circleDecorationRight" } as Image,
  closeDialog: { class: "closeDialog" } as Image,
  closeDialogWhite: { class: "closeDialogWhite" } as Image,
  comparePlans: {
    freeAvailable: { class: "comparePlansFreeAvailable" } as Image,
    freeUnavailable: { class: "comparePlansFreeUnavailable" } as Image,
    premiumAvailable: { class: "comparePlansPremiumAvailable" } as Image,
    premiumUnavailable: { class: "comparePlansPremiumUnavailable" } as Image,
    ultimateAvailable: { class: "comparePlansUltimateAvailable" } as Image,
  },
  disguiseIcon: { class: "disguiseIcon" } as Image,
  expiration: {
    background: { class: "expirationBackground" } as Image,
    second: {},
    warmup: { class: "expirationWarmup" } as Image,
  },
  expirationPattern: { class: "expirationPattern" } as Image,
  freeTrial: {
    featuresHeader: { class: "freeTrialFeaturesHeader" } as Image,
    headerIcon: { class: "freeTrialHeaderIcon" } as Image,
    trialStep1: { class: "freeTrialTrialStep1" } as Image,
    trialStep2: { class: "freeTrialTrialStep2" } as Image,
    trialStep3: { class: "freeTrialTrialStep3" } as Image,
  },
  halloween: {
    banner: { class: "halloweenBanner" } as Image,
    footer: { class: "halloweenFooter" } as Image,
    header: { class: "halloweenHeader" } as Image,
  },
  headerBackground: { class: "headerBackground" } as Image,
  importImage: { class: "importImage" } as Image,
  importImageV2: { class: "importImageV2" } as Image,
  info: { class: "info" } as Image,
  logo: { class: "logo" } as Image,
  mashable: { class: "mashable" } as Image,
  multistep: {
    happyUsers: { class: "multistepHappyUsers" } as Image,
    lockImage: { class: "multistepLockImage" } as Image,
    ring: { class: "multistepRing" } as Image,
    stars: { class: "multistepStars" } as Image,
  },
  newYorkTimes: { class: "newYorkTimes" } as Image,
  patternlockIcon: { class: "patternlockIcon" } as Image,
  premium: {
    default: {
      checkBox: { class: "premiumDefaultCheckBox" } as Image,
      checkBoxUnchecked: { class: "premiumDefaultCheckBoxUnchecked" } as Image,
      closeDialog: { class: "premiumDefaultCloseDialog" } as Image,
    },
    long: {
      adfree: { class: "premiumLongAdfree" } as Image,
      breakin: { class: "premiumLongBreakin" } as Image,
      camera: { class: "premiumLongCamera" } as Image,
      cloud: { class: "premiumLongCloud" } as Image,
      custom: { class: "premiumLongCustom" } as Image,
      decoy: { class: "premiumLongDecoy" } as Image,
      trash: { class: "premiumLongTrash" } as Image,
      wireless: { class: "premiumLongWireless" } as Image,
    },
    oneTime: {
      lightning: { class: "premiumOneTimeLightning" } as Image,
      sparkle: { class: "premiumOneTimeSparkle" } as Image,
    },
    promo: {
      adfree: { class: "premiumPromoAdfree" } as Image,
      breakin: { class: "premiumPromoBreakin" } as Image,
      cloud: { class: "premiumPromoCloud" } as Image,
      decoy: { class: "premiumPromoDecoy" } as Image,
      disguise: { class: "premiumPromoDisguise" } as Image,
      pattern: { class: "premiumPromoPattern" } as Image,
      trash: { class: "premiumPromoTrash" } as Image,
      wireless: { class: "premiumPromoWireless" } as Image,
    },
    return: {
      bannerBackground: { class: "premiumReturnBannerBackground" } as Image,
      bannerIcon: { class: "premiumReturnBannerIcon" } as Image,
      star: { class: "premiumReturnStar" } as Image,
      ticketTail: { class: "premiumReturnTicketTail" } as Image,
    },
  },
  premiumIcon: { class: "premiumIcon" } as Image,
  privateSecureIcon: { class: "privateSecureIcon" } as Image,
  ratingIcon: { class: "ratingIcon" } as Image,
  socialProof: { class: "socialProof" } as Image,
  starRatings: { class: "starRatings" } as Image,
  topMobile: { class: "topMobile" } as Image,
  trophy: { class: "trophy" } as Image,
  ultimate: {
    background: { class: "ultimateBackground" } as Image,
    blackFriday: {
      bannerBackground: {
        class: "ultimateBlackFridayBannerBackground",
      } as Image,
      bannerIcon: { class: "ultimateBlackFridayBannerIcon" } as Image,
    },
    features: {
      alphanumericIcon: { class: "ultimateFeaturesAlphanumericIcon" } as Image,
      dualLockIcon: { class: "ultimateFeaturesDualLockIcon" } as Image,
      duplicateDetectionIcon: {
        class: "ultimateFeaturesDuplicateDetectionIcon",
      } as Image,
      locationLockIcon: { class: "ultimateFeaturesLocationLockIcon" } as Image,
      organizationModalIcon: {
        class: "ultimateFeaturesOrganizationModalIcon",
      } as Image,
      searchFilterIcon: { class: "ultimateFeaturesSearchFilterIcon" } as Image,
      securityModalIcon: {
        class: "ultimateFeaturesSecurityModalIcon",
      } as Image,
      subalbumsIcon: { class: "ultimateFeaturesSubalbumsIcon" } as Image,
    },
    icon: { class: "ultimateIcon" } as Image,
  },
  washingtonPost: { class: "washingtonPost" } as Image,
  waves: { class: "waves" } as Image,
  yellowProLogo: { class: "yellowProLogo" } as Image,
}

export default images
